import { Nullable, TPageType } from "../../../types/common";
import { IBriefProduct } from "../../../types/product/ibrief-product/ibrief-product.interface";
import { hasBuyGetStatusNeither } from "../../../types/product/ibrief-product/ibrief-product.functions";

export const shouldShowBuyGetWarning = (
  isBuyGet: Nullable<boolean>,
  products?: IBriefProduct[]
): boolean => Boolean(isBuyGet && products && hasBuyGetStatusNeither(products));

export const isBuyGetEnabled = (isBuyGet: Nullable<boolean>, pageType: TPageType): boolean =>
  Boolean(isBuyGet) && pageType === "work-orders";
